var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-class":_vm.$style.enter,"enter-active-class":_vm.$style.enterActive,"enter-to-class":_vm.$style.enterTo,"leave-class":_vm.$style.leave,"leave-active-class":_vm.$style.leaveActive,"leave-to-class":_vm.$style.leaveTo}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }